import LayoutContainer from 'components/Common/LayoutContainer'
import Pane from 'components/Common/Pane'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { getThemeClassName } from 'lib/theme/themeUtils'
import { rem } from 'polished'
import styled from 'styled-components'

const Root = styled(Pane)`
  padding: ${rem(32)} 0;

  ${mediaQueryUp.tablet} {
    padding: ${rem(64)} 0;
  }
`

interface IframeProps {
  frameHeight?: string
  mobileFrameHeight?: string
}

const StyledIframe = styled.iframe<IframeProps>`
  width: 100%;
  height: ${props => props.mobileFrameHeight};
  border: none;

  ${mediaQueryUp.tablet} {
    height: ${props => props.frameHeight};
  }
`

function ContentfulIframeWrapper(props: App.ComponentIframe) {
  return (
    <Root className={getThemeClassName({ mobile: 'inverse' })}>
      <LayoutContainer>
        <StyledIframe
          allow="fullscreen"
          src={props.url}
          title={props.title}
          frameHeight={`${props.frameHeight}vh`}
          mobileFrameHeight={`${props.mobileFrameHeight}vh`}
          sandbox="allow-scripts allow-popups allow-popups-to-escape-sandbox allow-same-origin"
        />
      </LayoutContainer>
    </Root>
  )
}

export default ContentfulIframeWrapper
